import { render, staticRenderFns } from "./tabsTable.vue?vue&type=template&id=9ff97a40&scoped=true&"
import script from "./tabsTable.vue?vue&type=script&lang=js&"
export * from "./tabsTable.vue?vue&type=script&lang=js&"
import style0 from "./tabsTable.vue?vue&type=style&index=0&id=9ff97a40&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff97a40",
  null
  
)

export default component.exports